import { LOADING } from "../../constants/constant";
import {
  GET_DOWNLOAD_RCS_DISABLED_NUMBERS_REQUESTED,
  GET_DOWNLOAD_RCS_DISABLED_NUMBERS_SUCCESS,
  GET_DOWNLOAD_RCS_DISABLED_NUMBERS_FAILED,
  GET_DOWNLOAD_RCS_DISABLED_NUMBERS_RESET_STATE,
} from "../actions/ActionType";

const initialState = {
  status: "INIT",
  isLoading: false,
};

export default function getRcsDisabledNumbersReducer(state = initialState, action) {
  switch (action.type) {
    case GET_DOWNLOAD_RCS_DISABLED_NUMBERS_REQUESTED:
      let reqstState = Object.assign({}, state);
      reqstState.isLoading = true;
      reqstState.status = LOADING;
      return reqstState;

    case GET_DOWNLOAD_RCS_DISABLED_NUMBERS_SUCCESS:
      let userRes = Object.assign({}, state);
      userRes.status = action.data.status_message;
      userRes.statusCode = action.data.status_code;
      userRes.data = action.data;
      userRes.isLoading = false;

      console.log("Hello 123", JSON.stringify(action.data))

      return userRes;

    case GET_DOWNLOAD_RCS_DISABLED_NUMBERS_FAILED:
      return Object.assign({}, state, action.error);

    case GET_DOWNLOAD_RCS_DISABLED_NUMBERS_RESET_STATE:
      return initialState;

    default:
      return state;
  }
}
